import type { MapId } from '../engine/types.js';
import { GOLARION_ART } from '../data/golarion-art.js';
import { STANDARD_ART } from '../data/standard-art.js';
import type { MapArtData } from './map-art.js';

/** Each map's board art, beside `MAPS` (the rules side) in `src/data/maps.ts`. */
export const ART_OF: Record<MapId, MapArtData> = {
  standard: STANDARD_ART,
  golarion: GOLARION_ART,
};
